import { OptionInput } from "@brexhq/component-library";
import * as React from "react";

import { Container } from "@brexhq/next/src/components/layout/Container/Container";
import { useFormSubmissionContext } from "@brexhq/next/src/components/modules/LeadForm/FormSubmissionProvider";
import { useLeadFormModuleContext } from "@brexhq/next/src/components/modules/LeadForm/LeadFormModuleProvider";
import { GTMFormPageTemplate } from "@brexhq/next/src/components/modules/LeadForm/Steps/PageTemplates/GTMFormPageTemplate";
import { LeadFormSteps } from "@brexhq/next/src/components/modules/LeadForm/machines/types";
import { LeadFormValues } from "@brexhq/next/src/components/modules/LeadForm/sharedTypes";

import { employeeCountOptionsOBS4 } from "../../helpers/leadFormFields";

export const GTMNon3PStepOne: React.FC = () => {
  const {
    submit,
    prev,
    form: { getValues, fields },
  } = useFormSubmissionContext();

  const { customSubmitButtonLabel, customProgramName, customFormTitle } =
    useLeadFormModuleContext();

  /** Checks if fields are valid to disable */
  const validFields = !!getValues("employeeCount");

  const fieldList: (keyof LeadFormValues)[] = React.useMemo(
    () => ["employeeCount"],
    [],
  );

  const onSubmit = React.useCallback(
    async (event) => {
      /**
       * Handles form submission including validations.
       * Reference FormSubmissionProvider.tsx for more context
       */
      submit({
        event,
        fields: fieldList,
        prevStep: LeadFormSteps.userInfo,
      });
    },
    [fieldList, submit],
  );

  const onPrev = React.useCallback(() => {
    prev(fieldList);
  }, [fieldList, prev]);

  return (
    <GTMFormPageTemplate
      title={customFormTitle ?? "Additional information"}
      step={LeadFormSteps.gtmNon3PStepOne}
      programName={customProgramName}
      nextAction={{
        label: customSubmitButtonLabel ?? "Continue",
        loading: false,
        disabled: !validFields,
        onClick: onSubmit,
      }}
      prevAction={{
        label: "Back",
        onClick: onPrev,
      }}
    >
      <Container
        display="flex"
        gap="sml"
        direction="column"
        margin={{
          LRG: [0, 0, "sml", 0],
          MED: [0, 0, "sml", 0],
          SML: [0, 0, "sml", 0],
        }}
      >
        <OptionInput
          {...fields.employeeCount}
          size="large"
          options={employeeCountOptionsOBS4}
          label="Employee count"
        />
      </Container>
    </GTMFormPageTemplate>
  );
};
